import { useEffect, useState } from 'react';
import { UserModel } from 'shared/types/User';

import { useDBSyncContext } from '@/context/DBSyncContext';
import { useDatabase } from '@/hooks/useDatabase';
import { fetchUserById } from '@/services/user/user';

function useUserById(userId?: string) {
    const { getDatabase } = useDatabase();
    const { isSyncInProgress } = useDBSyncContext();
    const [user, setUser] = useState<UserModel | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!userId || isSyncInProgress) {
            if (!userId) setUser(null);
            return;
        }

        let cancelled = false;

        setIsLoading(true);
        fetchUserById(userId, getDatabase())
            .then((result) => {
                if (!cancelled) setUser(result);
            })
            .catch(() => {
                if (!cancelled) setUser(null);
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [userId, getDatabase, isSyncInProgress]);

    return { user, isLoading };
}

export default useUserById;
